var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-h6 text-md-h4 font-weight-medium baColorDeepBlueText--text"},[_vm._t("default",function(){return [_vm._v("title")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }